'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["contextualNodeAttributes"];
import tinymce from 'tinymce';
import { OLAF } from 'HubStyleTokens/colors';
import ColorPickerToolbarButton from 'rich-text-lib/components/toolbar/ColorPickerToolbarButton';
import { EditIcon } from 'foundations-assets';
import { getColorPicker } from '../../../components/ColorPicker';
import { CANVAS_BORDER_COLOR } from '../../../constants/toolbar';
import { jsx as _jsx } from "react/jsx-runtime";
export function addContextualBorderColorControl(editor) {
  const handleColorChange = (target, color) => {
    editor.fire('hsBorderColorChange', {
      target,
      color
    });
  };
  const ColorPicker = getColorPicker(editor, {
    includeAlpha: false
  });
  const renderColorPicker = renderProps => {
    // Alpha defaults to 0 when there is no `borderColor`
    const showResetToDefault = renderProps.alpha !== 0;
    return /*#__PURE__*/_jsx(ColorPicker, Object.assign({}, renderProps, {
      showResetToDefault: showResetToDefault
    }));
  };
  tinymce.canvas.addButton(editor, CANVAS_BORDER_COLOR, {
    renderControl: props => {
      const {
          contextualNodeAttributes
        } = props,
        rest = _objectWithoutPropertiesLoose(props, _excluded);
      const {
        borderColor,
        borderColorTooltip,
        activeElement
      } = contextualNodeAttributes;
      return /*#__PURE__*/_jsx(ColorPickerToolbarButton, Object.assign({
        "data-test-id": "color-picker-bordercolor",
        tooltip: borderColorTooltip,
        icon: "edit",
        Icon: EditIcon,
        color: borderColor,
        defaultColor: OLAF,
        defaultAlpha: 0,
        onColorChange: handleColorChange.bind(null, activeElement),
        renderColorPicker: renderColorPicker
      }, rest));
    }
  });
}